// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rd {
  width: 16px;
  height: 16px;
  border: 1.5px solid var(--border);
  border-radius: 999px;
  background: var(--bg-alt);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  flex-shrink: 0;
  transition:
    background 100ms,
    border-color 100ms;
}

.rd.on {
  border-color: var(--signal);
}

.rd.on::after {
  content: '';
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: var(--signal);
}

.rd--disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/ui/Radio/Radio.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,oBAAoB;EACpB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV,cAAc;EACd;;sBAEoB;AACtB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":[".rd {\n  width: 16px;\n  height: 16px;\n  border: 1.5px solid var(--border);\n  border-radius: 999px;\n  background: var(--bg-alt);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  padding: 0;\n  flex-shrink: 0;\n  transition:\n    background 100ms,\n    border-color 100ms;\n}\n\n.rd.on {\n  border-color: var(--signal);\n}\n\n.rd.on::after {\n  content: '';\n  width: 8px;\n  height: 8px;\n  border-radius: 999px;\n  background: var(--signal);\n}\n\n.rd--disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
